(function () {
  var collectionsCache = {};

  function fetchCollections(query) {
    var q = query.trim();
    if (!q) return Promise.resolve([]);
    var cacheKey = q.toLowerCase();
    if (collectionsCache[cacheKey]) return Promise.resolve(collectionsCache[cacheKey]);

    return fetch(
      '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=collection&resources[limit]=10&resources[options][fields]=title'
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var collections = [];
        if (data.resources && data.resources.results && data.resources.results.collections) {
          collections = data.resources.results.collections.map(function (c) {
            return { title: c.title, url: c.url, handle: c.handle || '' };
          });
        }
        collectionsCache[cacheKey] = collections;
        return collections;
      })
      .catch(function () { return []; });
  }

  function hideSuggestions() {
    document.querySelectorAll('.mb-24').forEach(function (el) {
      var heading = el.querySelector('h3');
      if (heading && el.querySelector('ul[role="group"]')) {
        el.classList.add('predictive-search__suggestions-hidden');
      }
    });
  }

  function showSuggestions() {
    document.querySelectorAll('.predictive-search__suggestions-hidden').forEach(function (el) {
      el.classList.remove('predictive-search__suggestions-hidden');
    });
  }

  function renderPills(matches, container) {
    var list = container.querySelector('.brand-search-results__list');
    if (!list) return;
    if (matches.length > 0) {
      list.innerHTML = matches
        .map(function (b) {
          return (
            '<a href="' + b.url + '" class="brand-search-results__pill">' +
            b.title.replace(/</g, '&lt;').replace(/>/g, '&gt;') +
            '</a>'
          );
        })
        .join('');
      container.classList.add('has-results');
      hideSuggestions();
    } else {
      container.classList.remove('has-results');
      list.innerHTML = '';
    }
  }

  function ensureBrandsContainer(parent) {
    if (!parent) return null;
    var existing = parent.querySelector('.brand-search-results');
    if (existing) return existing;
    var div = document.createElement('div');
    div.className = 'brand-search-results';
    div.innerHTML =
      '<h3 class="h5 mt-0 mb-8 brand-search-results__heading">Brands</h3>' +
      '<div class="brand-search-results__list"></div>';
    parent.insertBefore(div, parent.firstChild);
    return div;
  }

  function patchPredictiveSearch() {
    if (typeof BlsSearchShopify === 'undefined') return;

    var origRender = BlsSearchShopify.renderSearchResults;
    BlsSearchShopify.renderSearchResults = function (resultsMarkup) {
      origRender.call(this, resultsMarkup);
      var query =
        (document.querySelector('input[type="search"]')?.value || '').trim();
      if (!query) return;
      var predictiveEl = document.querySelector('[data-predictive-search]');
      if (!predictiveEl) return;
      var container = ensureBrandsContainer(predictiveEl);
      if (!container) return;
      fetchCollections(query).then(function (matches) {
        renderPills(matches, container);
      });
    };

    var origClose = BlsSearchShopify.close;
    BlsSearchShopify.close = function (clearSearchTerm) {
      origClose.call(this, clearSearchTerm);
      if (clearSearchTerm) {
        document.querySelectorAll('.brand-search-results').forEach(function (c) {
          c.classList.remove('has-results');
          var list = c.querySelector('.brand-search-results__list');
          if (list) list.innerHTML = '';
        });
        showSuggestions();
      }
    };
  }

  function initSearchPage() {
    var searchPageInput = document.getElementById('Search-In-Page');
    var productGridContainer = document.getElementById('productgridcontainer');
    if (!searchPageInput || !productGridContainer) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'main-search-brands';
    var brandsContainer = ensureBrandsContainer(wrapper);
    productGridContainer.insertBefore(wrapper, productGridContainer.firstChild);

    var initialQuery = searchPageInput.value.trim();
    if (initialQuery && brandsContainer) {
      fetchCollections(initialQuery).then(function (matches) {
        renderPills(matches, brandsContainer);
      });
    }

    var debounceTimer;
    searchPageInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var query = searchPageInput.value.trim();
        if (!query) {
          brandsContainer.classList.remove('has-results');
          return;
        }
        fetchCollections(query).then(function (matches) {
          renderPills(matches, brandsContainer);
        });
      }, 300);
    });
  }

  function init() {
    patchPredictiveSearch();
    initSearchPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
